module.exports = __webpack_public_path__ + "fonts/NanumSquareOTFB.85761192.woff";